"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using double underscores (`__` `__`).
 * Matches tags of the form `__variable__` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello __variable__';
 * const result = replaceTags(text, { variable: 'world' }, DoubleUnderscores);
 * console.log(result); // Output: 'Hello world'
 */
var DoubleUnderscores = {
    name: "Double Underscores",
    openingTag: "__",
    closingTag: "__",
    tagPattern: /__+.+?__+/g,
    tagStartPattern: /^__/,
    tagEndPattern: /__$/,
};
exports.default = DoubleUnderscores;
